import type {ReactNode} from 'react';

/** Secondary detail stays in document flow; native disclosure preserves form
 * values, keyboard access and browser validation without a second scrollbar. */
export function RecordDisclosure({title,children,open=false,className=''}:{title:string;children:ReactNode;open?:boolean;className?:string}){
 return <details className={'record-disclosure '+className} open={open||undefined}>
  <summary>{title}</summary><div className="record-disclosure__body">{children}</div>
 </details>;
}
